import { CommandBar, Stack } from '@fluentui/react';

export const MenuStack = styled(Stack)`
    position: fixed;
    background-color: white;
    justify-content: center;
    minheight: 44;
    z-index: 99999;
    width: 100%;
    display: block;
    padding-left: 20px;
`;
export const MenuCommandBar = styled(CommandBar)`
    .ms-OverflowSet-item {
        margin-left: 5px;
        margin-right: 5px;
    }
    [class*='menuItemSelected'] {
        border-width: 0px 0px 2px;
        border-top-style: initial;
        border-right-style: initial;
        border-left-style: initial;
        border-top-color: initial;
        border-right-color: initial;
        border-left-color: initial;
        border-image: initial;
        border-bottom-color: transparent;
        border-color: rgb(0, 120, 215);
        font-weight: 600;
        text-decoration: none;
        border-bottom-style: solid;
        width: fit-content;
    }
`;
